// import PatientList from './List';
import PatientExport from './Export';

export {
  PatientExport,
  // PatientList
}


// WEBPACK FOOTER //
// ./src/views/Patient/index.js